"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  // 1. Effets de bord
  // --
  // 2. Informations globales
  // --
  // 3. Type de composant
  // --
  // 4. Modificateurs de template
  // --
  // 5. Dépendances des templates
  // --
  // 6. Composition
  // --
  // 7. Interface
  // --
  // 8. État local (propriétés réactives locales)
  // --
  data: function data() {
    return {
      // A surcharger dans le composant utilisant le mixin
      mixinEvents: {
        export: 'xxx_EXPORT',
        exported: 'xxx_EXPORTED'
      }
    };
  },
  // 9. Évènements
  // --
  created: function created() {
    console.log('[Mixins] exportListMixin -> created !');

    if (this.mixinEvents.export === 'xxx_EXPORT') {
      console.warn('[Mixins] exportListMixin -> L\'événement \'xxx_EXPORT\' n\'est pas configuré dans le composant utilisant le mixin \'exportListMixin\'');
    }

    if (this.mixinEvents.exported === 'xxx_EXPORTED') {
      console.warn('[Mixins] exportListMixin -> L\'événement \'xxx_EXPORTED\' n\'est pas configuré dans le composant utilisant le mixin \'exportListMixin\'');
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log('[Mixins] exportListMixin -> mounted !');

    _eventBus.EventBus.$on(this.mixinEvents.export, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
        var format;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                format = _ref.format;
                console.log("[Mixins] exportListMixin -> Listening to Event '".concat(_this.mixinEvents.export, "' in order to export data list in format '").concat(format, "'"));
                _context.t0 = format;
                _context.next = _context.t0 === 'excel' ? 5 : _context.t0 === 'pdf' ? 8 : 11;
                break;

              case 5:
                _context.next = 7;
                return _this.generateExcelFile();

              case 7:
                return _context.abrupt("break", 11);

              case 8:
                _context.next = 10;
                return _this.generatePdfFile();

              case 10:
                return _context.abrupt("break", 11);

              case 11:
                _eventBus.EventBus.$emit(_this.mixinEvents.exported, {
                  format: format
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  beforeDestroy: function beforeDestroy() {
    console.log('[Mixins] exportListMixin -> beforeDestroy !');

    _eventBus.EventBus.$off(this.mixinEvents.export);
  },
  // 10. Propriétés non réactives
  // --
  methods: {
    generateExcelFile: function generateExcelFile() {
      console.log('[Mixins] exportListMixin -> generateExcelFile !');
      console.warn('[Mixins] exportListMixin -> La méthode \'generateExcelFile\' n\'est pas implémentée dans le composant utilisant le mixin \'exportListMixin\'');
    },
    generatePdfFile: function generatePdfFile() {
      console.log('[Mixins] exportListMixin -> generateExcelFile !');
      console.warn('[Mixins] exportListMixin -> La méthode \'generatePdfFile\' n\'est pas implémentée dans le composant utilisant le mixin \'exportListMixin\'');
    }
  } // 11. Rendu
  // --

};
exports.default = _default;